
import { defineComponent } from 'vue'
import TokenGate from '@/components/TokenGate.vue'
import ScreenNav from '@/components/ScreenNav.vue'

export default defineComponent({
  components: { TokenGate, ScreenNav },
})
